import { FETCH_STATUSES } from 'resources'

import actions from './actions'

const initialState = {
  pollfishStatus: FETCH_STATUSES.NOOP,
  pollfishSurveys: [],
}

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case actions.fetchPollfish.INIT_TYPE: {
      return {
        ...state,
        pollfishStatus: FETCH_STATUSES.FETCHING,
      }
    }
    case actions.fetchPollfish.SUCCESS_TYPE: {
      return {
        ...state,
        pollfishStatus: FETCH_STATUSES.SUCCESS,
        pollfishSurveys: payload.surveys.map((survey) => ({
          ...survey,
          loi: survey.time,
          provider: 'pollfish',
        })),
      }
    }
    case actions.fetchPollfish.FAILURE_TYPE: {
      return {
        ...state,
        pollfishStatus: FETCH_STATUSES.FAILURE,
        pollfishSurveys: [],
      }
    }
    case 'RESET': {
      return initialState
    }
    default:
      return state
  }
}

export default reducer
